// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bpg-title[data-v-d5633b96]{font-size:10px;margin:2.6em 0}.bpg-title *[data-v-d5633b96]{font-size:2em;font-weight:400}.mobile-section img[data-v-d5633b96]{width:40%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
